import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import Button from "./Button"

import { media, mixins } from "../styles"

const Opener = styled.div`
  appearance: none;
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  display: block;
  padding: 0;
  text-decoration: none;
  width: 100%;
`

const Teaser = styled.div`
  align-items: center;
  background: ${({ theme }) => theme.greyLight};
  border-radius: 25px;
  color: ${({ theme }) => theme.spaceblue};
  display: flex;
  flex-direction: column;
  gap: 25px;
  padding: 25px 0 0 0;
  text-align: center;
  width: 100%;

  &:hover {
    .button {
      background-color: ${({ theme }) => theme.spaceblue};
      color: ${({ theme }) => theme.white};
    }
  }

  @media ${media.md} {
    flex-flow: row nowrap;
    gap: 25px;
    padding: 0 0 0 40px;
    text-align: left;
  }

  h2 {
    ${mixins.title6}
    margin: 0;
  }

  .button {
    @media ${media.md} {
      margin-left: auto;
    }
  }
`

const Illustration = styled.div`
  align-items: center;
  display: flex;
  flex: none;
  justify-content: center;
  width: 70px;
  ${(props) => (props.$iconSize ? `width: ${props.$iconSize}px;` : "")}

  @media ${media.md} {
    width: 90px;
    ${(props) => (props.$iconSize ? `width: ${props.$iconSize}px;` : "")}
  }

  img,
  svg {
    display: block;
    height: auto;
    max-width: 100%;
  }
`

const Content = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 25px;
  padding: 0 20px 25px;

  @media ${media.md} {
    flex-flow: row nowrap;
    flex: 1;
    padding: 25px 40px 25px 0;
    text-align: left;
  }
`

const CtaLinkBar = ({
  as,
  buttonText,
  className,
  header,
  iconSize,
  intl,
  illustration,
  onClick,
  to,
}) => {
  return (
    <Opener as={as} to={to} intl={intl} className={className} onClick={onClick}>
      <Teaser>
        {illustration && (
          <Illustration $iconSize={iconSize}>
            <img alt={header} src={illustration} aria-hidden="true" />
          </Illustration>
        )}
        <Content>
          <h2>{header}</h2>
          <Button as="span" arrow outline>
            {buttonText}
          </Button>
        </Content>
      </Teaser>
    </Opener>
  )
}

CtaLinkBar.propTypes = {
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func])
    .isRequired,
  buttonText: PropTypes.string.isRequired,
  className: PropTypes.string,
  header: PropTypes.string.isRequired,
  iconSize: PropTypes.number,
  illustration: PropTypes.node,
  onClick: PropTypes.func,
  to: PropTypes.string.isRequired,
}

export default CtaLinkBar
